import React, { createContext, useContext, useEffect } from "react";
import { usePOSProducts } from "../../../hooks/usePOSProducts";
import { io } from "socket.io-client";

const POSProductsContext = createContext();

let socket;

export const POSProductsProvider = ({ children }) => {
    const posProducts = usePOSProducts();

    useEffect(() => {
        // Connect only once
        if (!socket) {
            socket = io(process.env.REACT_APP_SOCKET_URL, {
                transports: ["websocket"],
                withCredentials: true
            });
        }

        // Listen for products_updated event
        socket.on("products_updated", () => {
            posProducts.fetchProducts();
        });

        // Cleanup on unmount
        return () => {
            if (socket) {
                socket.off("products_updated");
            }
        };
        // Only run once, but re-attach if fetchProducts changes
    }, [posProducts, posProducts.fetchProducts]);

    return (
        <POSProductsContext.Provider value={posProducts}>
            {children}
        </POSProductsContext.Provider>
    );
};

export const usePOSProductsContext = () => useContext(POSProductsContext);